export function createPuesto() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    Familia: '',
    Nivel: 0,
    Descripcion: '',
    ClaveErp: '',
    EsActivo: true
  };
}
